import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { SummaryCashModel } from '../../models/summary-cash.model';
import { LoadCashsSuccess } from '../actions/cash.actions';
import { CashActions, CashActionTypes } from '../actions/cash.actions';


export interface CashState {
  items: SummaryCashModel[];
  total: number;
  res: PaginableResponseModel<SummaryCashModel>;
  selected: SingleResponseModel<SummaryCashModel> | null;
  loading: boolean;
  error: any
}


export const initalState: CashState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function CashReducer(
  state = initalState,
  action: CashActions
): CashState {
  switch (action.type) {
    case CashActionTypes.LoadCashs:
      return { ...state, loading: true, error: null };

    case CashActionTypes.LoadCashsSuccess:
      const { items, total } = (action as LoadCashsSuccess).payload;

      return {
        ...state,
        loading: false,
        error: null,
        items: items,
        total: total,
      };
    case CashActionTypes.LoadCashsFailure:
      return { ...state, loading: false, error: action.payload.error };

    case CashActionTypes.LoadCashSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
